import utilsStyles from '@/styles/modules/utils.module.scss';
import { formatCurrency } from '@/utils/formatters';
import type { LotteryEventDetail, LotteryPrice } from '../../types';
import styles from './ShippingAlert.module.scss';

function ShippingAlert({
  price,
  additionalShippingFeePerTimes,
}: { price: LotteryPrice; additionalShippingFeePerTimes?: number }) {
  return (
    <div className={`${styles.shippingAlert} ${utilsStyles.textSmall}`}>
      <span>{message(price, additionalShippingFeePerTimes)}</span>
    </div>
  );
}

function message(price: LotteryPrice, additionalShippingFeePerTimes?: number) {
  if (price.additionalShippingFee > 0 && price.shippingFee > 0) {
    return `配送手数料として初回${formatCurrency(price.shippingFee)}coinと初回以降
    ${additionalShippingFeePerTimes}回ごとに
    ${formatCurrency(price.additionalShippingFee)}coinがかかります。`;
  }
  if (price.additionalShippingFee > 0) {
    return `配送手数料として初回以降${additionalShippingFeePerTimes}回ごとに
    ${formatCurrency(price.additionalShippingFee)}coinがかかります。`;
  }
  return `初回のみ配送手数料として+${formatCurrency(price.shippingFee)}coinがかかります。`;
}

export default ShippingAlert;
